import { render, staticRenderFns } from "./KDateSelect.vue?vue&type=template&id=ba052156&"
import script from "./KDateSelect.vue?vue&type=script&lang=js&"
export * from "./KDateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports